export default __webpack_public_path__ + "img/fdGwrDtJ.3e1419e0.svg";